import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { spring } from 'react-motion';
import noop from 'lodash/noop';

import ToastsPlace from 'modules/messageSystem/components/ToastsPlace';
import InternetMeterToastPlace from '../VideoConference/ConnectionMeter/InternetMeterToastPlace';


const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  /** list of toast messages */
  toasts: PropTypes.arrayOf(PropTypes.shape({
    /** unique identifier of the message */
    id: PropTypes.string.isRequired,
    /** message in i18n format that will be displayed in toast */
    message: PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string,
      defaultMessage: PropTypes.string,
      values: PropTypes.object,
    }),
    /** show close button */
    showClose: PropTypes.bool,
  })),
  /** @type string classname that will be added to container classes */
  containerClassName: PropTypes.string,
  /** define to true for hebrew language */
  rtl: PropTypes.bool,
  /** function to delete toast message by it's id */
  removeToast: PropTypes.func,
};

const defaultProps = {
  toasts: [],
  containerClassName: '',
  rtl: false,
  removeToast: noop,
};

const VideoToastsPlace = ({ toasts, intl, ...props }) => {
  return (
    <ToastsPlace
      { ...props }
      innerComponent={ <InternetMeterToastPlace /> }
      toasts={ toasts.map(({ message, ...toast }) => ({
        ...toast,
        message: intl.formatMessage(message, message.values),
      })) }
      willLeave={ () => ({ x: spring(0), y: spring(-50) }) }
      willEnter={ () => ({ x: 100, y: 10 }) }
      styleModificator={ (items) => items.map((item) => ({
        key: item.id,
        data: item,
        style: { x: 100, y: 10 },
      })) }
    />
  );
};

VideoToastsPlace.propTypes = propTypes;
VideoToastsPlace.defaultProps = defaultProps;

export default injectIntl(VideoToastsPlace);
